import { render, staticRenderFns } from "./FTP.vue?vue&type=template&id=e2747814&"
import script from "./FTP.vue?vue&type=script&lang=js&"
export * from "./FTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports